




import { Component, Vue } from "vue-property-decorator";
import { IMenuListItem } from "@/lib/interfaces/menu-list-item.interface";
import TheNavigationLayout from "./TheNavigationLayout.vue";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { FeatureModule } from "@/store/modules/feature.store";
import { PartnerModule } from "@/store/modules/partner";

@Component({
  components: {
    TheNavigationLayout
  }
})
export default class TheDigitalSignatureList extends Vue {
  get partnerId() {
    return PartnerModule.partner._id;
  }

  get items(): IMenuListItem[] {
    return [
      {
        icon: "mdi-file-document-outline",
        link: `/partners/${this.partnerId}/document`,
        isEnabled: FeatureModule.isDigitalSignatureEnabled.isSignEnabled,
        permission: {
          resource: ResourceEnum.SIGN,
          action: ActionEnum.READ,
          field: this.partnerId
        },
        text: "navigation.TheDigitalSignatureList.documents"
      },
      {
        icon: "mdi-file-sign",
        link: `/partners/${this.partnerId}/sign-request`,
        isEnabled: FeatureModule.isDigitalSignatureEnabled.isSignEnabled,
        permission: {
          resource: ResourceEnum.SIGN,
          action: ActionEnum.READ,
          field: this.partnerId
        },
        text: "navigation.TheDigitalSignatureList.signRequests"
      }
    ];
  }

  title = String(this.$t("navigation.TheDigitalSignatureList.title"));

  get isDigitalSignatureEnabled() {
    return FeatureModule.isDigitalSignatureEnabled.isSignEnabled;
  }
}
